import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }
}
